/** 카드 (DESIGN_SPEC 1·4장). --color-surface, 반경 16, 1px hairline. 그림자는 쓰지 않습니다 */
export function Card({ as: Element = 'div', className = '', children, ...rest }) {
    return (
        <Element className={`rounded-card border border-hairline bg-surface p-4 ${className}`} {...rest}>
            {children}
        </Element>
    );
}
